import React from 'react';
import propTypes from 'prop-types';
export const StopwatchIcon = ({ size, color, variant }) => {
  const sizeInPixel = `${size}px`;
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      width={sizeInPixel}
      height={sizeInPixel}
      className={variant}
      fill={color}
      viewBox="0 0 92 92"
      enableBackground="new 0 0 92 92"
      xmlSpace="preserve"
    >
      <path
        d="M81.3,19.6c0.8,0.7,1.7,1,2.7,1c1.1,0,2.2-0.4,3-1.3c1.5-1.6,1.4-4.2-0.3-5.7l-5.2-4.7c0,0,0,0,0,0s0,0,0,0l-5.2-4.7
   c-1.6-1.5-4.2-1.4-5.6,0.3c-1.5,1.6-1.4,4.2,0.3,5.7l2.2,2l-4,4.5c-4.6-3.4-9.9-5.9-15.7-7.2c-0.1-1.3-0.6-2.7-1.6-4
   c-1-1.4-3.1-3-6.9-3.2c-0.1,0-0.1,0-0.2,0c-3.5,0-5.5,1.5-6.6,2.8c-1.2,1.4-1.7,3.1-1.9,4.4C17.8,13.4,4,29.8,4,49.4
   c0,22.5,18.3,40.9,40.8,40.9c22.5,0,40.8-18.3,40.8-40.9c0-10.5-4-20.1-10.5-27.4l4-4.5L81.3,19.6z M44.8,82.2
   C26.7,82.2,12,67.5,12,49.4s14.7-32.8,32.8-32.8c18.1,0,32.8,14.7,32.8,32.8S62.9,82.2,44.8,82.2z M51.8,49.4c0,3.8-3.2,6.9-7,6.9
   c-3.8,0-6.8-3.1-6.8-6.9c0-2.3,1-4.4,3-5.6V27.6c0-2.2,1.8-4,4-4s4,1.8,4,4v16.2C51,45,51.8,47.1,51.8,49.4z"
      />
    </svg>
  );
};
StopwatchIcon.prototype = {
  size: propTypes.number,
  color: propTypes.string,
  variant: propTypes.string,
};
StopwatchIcon.defaultProps = {
  size: 18,
  color: 'black',
  varient: '',
};
